import clsxm from "@/lib/clsxm";
import {ButtonHTMLAttributes, FC, memo} from "react";

const TextButton: FC<
  {
    onClick?(): void;
    className?: string;
    text: string;
    isDisabled?: boolean;
  } & ButtonHTMLAttributes<HTMLButtonElement>
> = ({className, text, isDisabled, onClick, ...rest}) => {
  return (
    <button
      type="button"
      className={clsxm(
        "enabled:text-primary-dark-solid enabled:hover:text-primary-medium-solid disabled:text-neutral-grey-light cursor-pointer font-medium transition-all duration-150",
        className,
      )}
      disabled={isDisabled}
      onClick={onClick}
      {...rest}>
      <span>{text}</span>
    </button>
  );
};

export default memo(TextButton);
